import { render } from "./UpdateQwilrDefinitionTemplate.vue?vue&type=template&id=27caf25b&scoped=true"
import script from "./UpdateQwilrDefinitionTemplate.vue?vue&type=script&lang=js"
export * from "./UpdateQwilrDefinitionTemplate.vue?vue&type=script&lang=js"

import "./UpdateQwilrDefinitionTemplate.vue?vue&type=style&index=0&id=27caf25b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27caf25b"]])

export default __exports__